<app-back-header-atom
  icon="arrow-left"
  text="Détails de la commande"
  [textColor]="textColor()"
  [backgroundColor]="backgroundColor()"
  (navigationClick)="back()"
></app-back-header-atom>
